// Config + constants for the Careers application form.
// Kept as plain data so validation, rendering, and tests all share one source of truth.

export const POSITIONS = ["Sushi Chef", "Junior Chef", "Prep Cook", "Cashier", "Kitchen Helper"];

export const INITIAL_FORM = {
  name: "", email: "", phone: "", current_location: "",
  position: "Sushi Chef", years_experience: 0,
  past_employers: "", reference_name: "", reference_phone: "",
  clean_driving_record: null, can_work_military: null,
  desired_hourly_salary: "", availability: "", cover_note: "",
  // interview
  authorized_and_meets_requirements: null, has_real_id: null, work_type: "full_time",
  start_date: "", comfortable_learning_pos: null, food_service_experience: "",
  skill_to_improve: "", sushi_raw_experience: null, food_safety_certification: null,
  reliable_transportation: null, comfortable_food_safety: null, can_work_busy_hours: null,
  comfortable_taking_orders: null, unsafe_food_handling_response: "", shift_arrival_time: "",
  late_or_miss_shift_response: "", why_sandar_sushi: "",
};

// Every Yes/No interview question — all required. Order matches how they render.
export const YES_NO_QUESTIONS = [
  { k: "authorized_and_meets_requirements", label: "Are you legally authorized to work in the United States and able to meet the identification, background-check, and access requirements for this military installation?", shortLabel: "Authorization & installation requirements" },
  { k: "has_real_id", label: "Do you have a valid REAL ID?", shortLabel: "Valid REAL ID" },
  { k: "food_safety_certification", label: "Do you currently have a valid ServSafe Food Handler certification?", shortLabel: "Valid ServSafe Food Handler certification" },
  { k: "comfortable_learning_pos", label: "Are you comfortable learning new equipment and POS/cashier systems?", shortLabel: "Comfortable learning POS / new equipment" },
  { k: "sushi_raw_experience", label: "Do you have sushi or raw-seafood experience?", shortLabel: "Sushi / raw-seafood experience" },
  { k: "reliable_transportation", label: "Do you have reliable transportation?", shortLabel: "Reliable transportation" },
  { k: "clean_driving_record", label: "Do you have a clean driving record?", shortLabel: "Clean driving record" },
  { k: "can_work_military", label: "Are you able to work inside a military food court?", shortLabel: "Able to work in a military food court" },
  { k: "comfortable_food_safety", label: "Are you comfortable following strict food-safety and sanitation rules?", shortLabel: "Comfortable with strict food-safety rules" },
  { k: "can_work_busy_hours", label: "Can you work quickly during busy hours?", shortLabel: "Can work quickly during busy hours" },
  { k: "comfortable_taking_orders", label: "Are you comfortable taking orders, using a register, and helping customers?", shortLabel: "Comfortable taking orders / register / customers" },
];

// Only these are truly required — everything else is optional.
export const REQUIRED_FIELDS = [
  ["name", "Full name"],
  ["phone", "Phone"],
  ["email", "Email"],
  ["current_location", "Current location (City, State)"],
  ["position", "Position"],
  ["availability", "Availability"],
  ...YES_NO_QUESTIONS.map((q) => [q.k, q.shortLabel]),
  ["why_sandar_sushi", "Why you want to work at Sandar Sushi"],
];

export function isFilled(v) {
  if (v === null || v === undefined) return false;
  if (typeof v === "string") return v.trim().length > 0;
  if (typeof v === "boolean") return true;
  return true;
}
